"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLayersThree1 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconLayersThree1 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10579 11.5528C1.35278 11.0588 1.95345 10.8586 2.44743 11.1056L12.0002 15.882L21.553 11.1056C22.047 10.8586 22.6477 11.0588 22.8946 11.5528C23.1416 12.0468 22.9414 12.6474 22.4474 12.8944L12.8052 17.7155C12.7978 17.7192 12.7892 17.7236 12.7796 17.7285C12.6863 17.7761 12.4933 17.8747 12.2768 17.9153C12.094 17.9496 11.9064 17.9496 11.7236 17.9153C11.5072 17.8747 11.3141 17.7761 11.2208 17.7285C11.2112 17.7236 11.2026 17.7192 11.1952 17.7155L1.55301 12.8944C1.05903 12.6474 0.858803 12.0468 1.10579 11.5528Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10579 16.5528C1.35278 16.0588 1.95345 15.8586 2.44743 16.1056L12.0002 20.882L21.553 16.1056C22.047 15.8586 22.6477 16.0588 22.8946 16.5528C23.1416 17.0468 22.9414 17.6474 22.4474 17.8944L12.8052 22.7155C12.7978 22.7192 12.7892 22.7236 12.7796 22.7285C12.6863 22.7761 12.4933 22.8747 12.2768 22.9153C12.094 22.9496 11.9064 22.9496 11.7236 22.9153C11.5072 22.8747 11.3141 22.7761 11.2208 22.7285C11.2112 22.7236 11.2026 22.7192 11.1952 22.7155L1.55301 17.8944C1.05903 17.6474 0.858803 17.0468 1.10579 16.5528Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7236 1.08474C11.9064 1.05045 12.094 1.05045 12.2768 1.08474C12.4933 1.12535 12.6863 1.22388 12.7796 1.27149C12.7892 1.2764 12.7978 1.28076 12.8052 1.28446L22.4474 6.10558C22.7862 6.27497 23.0002 6.62123 23.0002 7C23.0002 7.37878 22.7862 7.72504 22.4474 7.89443L12.8052 12.7155C12.7978 12.7193 12.7892 12.7236 12.7796 12.7285C12.6863 12.7761 12.4933 12.8747 12.2768 12.9153C12.094 12.9496 11.9064 12.9496 11.7236 12.9153C11.5072 12.8747 11.3141 12.7761 11.2208 12.7285C11.2112 12.7236 11.2026 12.7192 11.1952 12.7155L1.55301 7.89443C1.21422 7.72504 1.00022 7.37878 1.00022 7C1.00022 6.62123 1.21422 6.27497 1.55301 6.10558L11.1952 1.28446C11.2026 1.28076 11.2112 1.27639 11.2208 1.27149C11.3141 1.22388 11.5072 1.12535 11.7236 1.08474Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 12L11.6422 16.8211C11.7734 16.8867 11.839 16.9195 11.9078 16.9324C11.9687 16.9438 12.0313 16.9438 12.0922 16.9324C12.161 16.9195 12.2266 16.8867 12.3578 16.8211L22 12M2 17L11.6422 21.8211C11.7734 21.8867 11.839 21.9195 11.9078 21.9324C11.9687 21.9438 12.0313 21.9438 12.0922 21.9324C12.161 21.9195 12.2266 21.8867 12.3578 21.8211L22 17M2 7L11.6422 2.17889C11.7734 2.1133 11.839 2.0805 11.9078 2.0676C11.9687 2.05616 12.0313 2.05616 12.0922 2.0676C12.161 2.0805 12.2266 2.1133 12.3578 2.17889L22 7L12.3578 11.8211C12.2266 11.8867 12.161 11.9195 12.0922 11.9324C12.0313 11.9438 11.9687 11.9438 11.9078 11.9324C11.839 11.9195 11.7734 11.8867 11.6422 11.8211L2 7Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconLayersThree1 = IconLayersThree1;
//# sourceMappingURL=IconLayersThree1.js.map